<template>
	<div v-if="gettingQuestionsResultText.length > 0" class="gettingQuestionsResultText">{{ gettingQuestionsResultText }}</div>
	
	<div v-if="needShowButton === true" class="buttonAndNearText">
		<button @click="handleGetQuestionsButtonClick" :disabled="buttonDisabled" class="getQuestionsButton">Начать новый тест</button><br>
	</div>
			
	<div className="questionBlockWrapper" v-if="needShowOneQuestion === true">
		<h2>Вопрос {{ currentQuestionIndex + 1 }} из 10.</h2>
		<div className="questionBlock" v-html="currentQuestion"></div>
		<div className="answersBlock">
			<div className="oneAnswer" v-for="(oneAnswerText, answerIndex) in answersOfCurrentQuestion"
			:key="answerIndex" @click="handleAnswerClick($event, currentQuestionIndex, answerIndex)">
				<div className="index">{{ answerIndex + 1 }}</div>
				<div className="text" v-html="oneAnswerText"></div>
			</div>
		</div>
	</div>
	
	<div className="resultBlockWrapper" v-if="needShowResult === true">
	
		<h2>Результаты ваших ответов</h2>
		<br>
		<div className="resultTextPhrase">Количество правильных ответов: {{ amountOfCorrectAnswers }} из 10.</div>
		<br>

		<template v-for="(answer, index) in $store.state.userAnswers" :key="index">
			<h2>Вопрос {{ index + 1 }}</h2>
			
			<div class="questionBlock marginBottom20" v-html=" $store.state.questionsArr[index].question"></div>

			<div class="resultTextPhrase">Ваш ответ:</div>

			<div class="answersBlock">
				<div class="oneAnswer" :class="{
					greenBackground: ($store.state.userAnswers[index] === Number($store.state.questionsArr[index].correctAnswer) - 1),
					redBackground: ($store.state.userAnswers[index] !== Number($store.state.questionsArr[index].correctAnswer) - 1),
				}">
					<div className="index">{{ $store.state.userAnswers[index] + 1 }}</div>
					<div className="text" v-html="$store.state.questionsArr[index].answers[$store.state.userAnswers[index]]"></div>
				</div>
			</div>
			
			<template v-if="($store.state.userAnswers[index] !== Number($store.state.questionsArr[index].correctAnswer) - 1)">
				<div class="resultTextPhrase">Правильный ответ:</div>

				<div class="answersBlock">
					<div class="oneAnswer">
						<div class="index">{{ $store.state.questionsArr[index].correctAnswer }}</div>
						<div class="text" v-html="$store.state.questionsArr[index].answers[$store.state.questionsArr[index].correctAnswer - 1]"></div>
					</div>
				</div>
			</template>
			
			<br>
			<br>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			gettingQuestionsResultText: '',
			buttonDisabled: false,
		};
	},

	mounted() {
		document.title = 'Тестирование знаний по фронтенду';
	},
	
	computed: {
		needShowButton() {
			if (this.$store.state.questionsArr.length === 10) {
				if (this.needShowResult === true) {
					return true;
				}
				return false;
			}
			return true;
		},
		
		amountOfCorrectAnswers() {
			let result = 0;
			for (let i = 0; i < this.$store.state.questionsArr.length; i++) {
				if (this.$store.state.userAnswers[i] === Number(this.$store.state.questionsArr[i].correctAnswer) - 1) {
					result++;
				}
			}
			return result;
		},
		
		needShowResult() {
			return this.$store.state.currentQuestionIndex === 10;
		},

		needShowOneQuestion() {
			return (this.$store.state.questionsArr.length > 1
			&& this.$store.state.currentQuestionIndex < this.$store.state.questionsArr.length);
		},
		
		currentQuestionIndex() {
			return this.$store.state.currentQuestionIndex;
		},
		
		currentQuestion() {
			if (this.$store.state.questionsArr[this.currentQuestionIndex]
				&& this.$store.state.questionsArr[this.currentQuestionIndex].question
			) {
				return this.$store.state.questionsArr[this.currentQuestionIndex].question;
			}
			
			return `Ошибка! Нет вопроса для показа. Запрашивается индекс массива номер ${this.currentQuestionIndex}.`;
		},
		
		answersOfCurrentQuestion() {
			if (this.$store.state.questionsArr[this.currentQuestionIndex]
				&& this.$store.state.questionsArr[this.currentQuestionIndex].answers
			) {
				return this.$store.state.questionsArr[this.currentQuestionIndex].answers;
			}

			return ['Ошибка! Это ненастоящий ответ!'];
		},
	},
	
	methods: {
		handleAnswerClick(e, questionIndex, answerIndex) {
			// "Моргаю" элементом, т.к. hover-эффект на смартфоне глючит.
			const elem = e.target.closest('.oneAnswer');
			if (elem !== null) {
				elem.classList.add('wasClicked');
				setTimeout(() => {
					elem.classList.remove('wasClicked');
				}, 50);
			}
			
			this.$store.commit('saveUserAnswer', { questionIndex, answerIndex });
			
			this.$store.commit('increaseCurrentQuestionIndex');

			if (this.needShowResult === true) { this.saveStatsToLocalStorage(); }
		},
		
		saveStatsToLocalStorage() {
			const date = Date.now();
			
			const nowResult = {
				date,
				questions: this.$store.state.questionsArr.length,
				correctAnswers: this.amountOfCorrectAnswers,
			};
			
			const fromLS = localStorage.getItem('frontendTestAllTimeStats');

			if (fromLS === null) {
				const nowResultStr = JSON.stringify([nowResult]);
				localStorage.setItem('frontendTestAllTimeStats', nowResultStr);
			}
			
			if (typeof fromLS === 'string') {
				let statsArr = JSON.parse(fromLS);
				if (Array.isArray(statsArr) !== true) {
					statsArr = [];
				}
				statsArr.push(nowResult);
				const statsStr = JSON.stringify(statsArr);
				localStorage.setItem('frontendTestAllTimeStats', statsStr);
			}			
		},
		
		handleGetQuestionsButtonClick() {
			this.buttonDisabled = true;
			this.$store.commit('clearAll');
			this.gettingQuestionsResultText = 'Отправляю запрос на сервер...';
			fetch('https://dmitriyzhuravlev.ru/php/frontendquiz/get.php')
			.then((r) => r.json())
			.then((data) => {
				this.gettingQuestionsResultText = `Получено ${data.length} вопросов.`;
				setTimeout(() => { this.gettingQuestionsResultText = ''; }, 1200);
				this.buttonDisabled = false;
				// console.log(data);
				this.$store.commit('saveNewQuestions', data);
			})
			.catch(() => {
				this.gettingQuestionsResultText = 'При получении вопросов с сервера возникла ошибка. Попробуйте нажать кнопку ещё раз.';
				this.buttonDisabled = false;
			});
		},
	},
};
</script>

<style scoped>
.gettingQuestionsResultText {
	color: #303030;
	font-size: 0.8em;
	box-sizing: border-box;
	border: 0px solid black;
	max-width: 800px;
	width: 100%;
	padding: 0.2em;
}

.buttonAndNearText {
	border: 0px solid black;
	padding: 0.2em;
	box-sizing: border-box;
	max-width: 800px;
	width: 100%;
}

.getQuestionsButton {
	font-size: 1em;
	font-family: sans-serif;
	margin: 0.4em 0 0.4em 0;
}

h2 {
	text-align: center;
	font-weight: normal;
	font-size: 1.2em;
	margin: 0;
}

.questionBlockWrapper, .resultBlockWrapper {
	border: 0px solid #464646;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 10px; 
}

.questionBlock {
	margin: 10px 20px 0px 20px;
	color: white;
	font-size: 20px;
	background-color: #454545;
	width: 100%;
	max-width: 800px;
	padding: 15px;
	box-sizing: border-box;
	border-radius: 5px;
	box-shadow: 3px 3px 3px 0px #c0c0c0;
	overflow: hidden;
}

.questionBlockWrapper h2, .resultBlockWrapper h2 {
	width: 100%;
	max-width: 800px;
	text-align: left;
	box-sizing: border-box;
	padding: 0px;
}

.answersBlock {
	display: block;
	width: 100%;
	max-width: 800px;
	box-sizing: border-box;
}

.oneAnswer {
	display: flex;
	margin: 20px 0px;
	color: black;
	font-size: 20px;
	background-color: #efefef;
	padding: 0px;
	border-radius: 5px;
	box-shadow: 3px 3px 3px 0px #e0e0e0;
	cursor: default;
}

.oneAnswer.wasClicked {
	background-color: #bfbfbf;
}

/* Внимание: ниже есть @media (hover: hover) для .oneAnswer */

.oneAnswer .index {
	display: flex;
	justify-content: center; 
	align-content: center;
	align-items: center;
	border-radius: 5px 0px 0px 5px;
	background-color: #606060;
	color: white;
	padding: 4px 10px;
}

.oneAnswer .text {
	padding: 5px 5px 5px 15px;
	word-break: normal;
	overflow-wrap: anywhere;
	border: 1px solid #606060;
	border-radius: 0px 5px 5px 0px;
	width: 100%;
}

.marginBottom20 {
	margin-bottom: 20px;
}

.resultTextPhrase {
	font-size: 20px;
	width: 100%;
	max-width: 800px;
	box-sizing: border-box;
	overflow: hidden;
	/* border: 1px solid black; */
}

.greenBackground {
	background-color: #bbf4bb;
}

.redBackground {
	background-color: #ff8080;
}

@media (hover: hover) {
	/* Этот блок сделан, чтобы на смартфонах hover-эффект не появлялся после клика */
	.questionBlockWrapper .oneAnswer:hover {
			background-color: #d0d0d0;
			box-shadow: 3px 3px 3px 0px #d0d0d0;
	}
}	
</style>
